exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host ::ng-deep .vertical-center-modal .ant-modal {\n  width: 1218px !important;\n  top: 100px; }\n\n:host ::ng-deep.ant-modal-content .ant-modal-close .ant-modal-close-x {\n  width: 25px !important;\n  height: 28px !important;\n  line-height: 26px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/shared/topupdetail/topupdetail.component.scss
// module id = 1155
// module chunks = 75